import { render, staticRenderFns } from "./cms-layout.vue?vue&type=template&id=3d8909f8&scoped=true&"
import script from "./cms-layout.vue?vue&type=script&lang=js&"
export * from "./cms-layout.vue?vue&type=script&lang=js&"
import style0 from "./cms-layout.vue?vue&type=style&index=0&id=3d8909f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8909f8",
  null
  
)

export default component.exports